import { Route, Routes, useLocation } from 'react-router-dom';
import { Agenda, FAQ, Home, Partners, Press, VentureNurturing, Register, Speakers, Startups, Venue, Volunteer, TYSubmission, HSForms, FormSuccess, Page404, TopInnovators, } from './pages';
import { Footer, NavBar, RibbonAdds, Schedule, Tickets } from './components';
import { useScrollToTop } from './hooks/useScrollToTop';

function App() {
   const { pathname } = useLocation()
   useScrollToTop()
   
   return (
      <div className="App">
         <NavBar />
         {!pathname.includes('form') && <RibbonAdds />}
         <Routes>
            <Route path='/' element={<Home />} />
            <Route path='startups' element={<Startups />} />
            <Route path='speakers' element={<Speakers />} />
            <Route path='partners' element={<Partners />} />
            <Route path='top-innovators' element={<TopInnovators />} />
            <Route path='venue' element={<Venue />} />
            <Route path='volunteer' element={<Volunteer />} />
            <Route path='press' element={<Press />} />
            <Route path='venture-nurturing' element={<VentureNurturing />} />
            <Route path='faq' element={<FAQ />} />
            <Route path='agenda/*' element={<Agenda />} >
               <Route path=':day' element={<Schedule />} />
            </Route>
            <Route path='registration/*' element={<Register />}>
               <Route path=':type' element={<Tickets />} />
            </Route>
            <Route path='forms/thank-you' element={<TYSubmission />} />
            <Route path='forms/:formid' element={<HSForms />} />
            <Route path='form-success' element={<FormSuccess />} />
            <Route path='*' element={<Page404 />} />
         </Routes>
         <Footer />
      </div >
   );
}

export default App;
